/** "1 card", "2 cards" — plain English plural for the common regular-noun case. */
export const pluralize = (count: number, noun: string): string =>
  `${count} ${noun}${count === 1 ? "" : "s"}`;
